//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import vueI18n from '@/vueI18n'
// import { i18n } from '@/vueI18n';
import moment from 'moment';

import { PlacePermissions } from '@/modules/place/place-permissions';
import { PlaceModel } from '@/modules/place/place-model';
const { fields } = PlaceModel;

export default {
  name: 'app-place-list-table',

  mounted() {
    this.doFetchFirstPage();
    this.doMountTable(this.$refs.table);
  },

  data() {
    return {
      filter: '',
      selection:[],
      selectedRow: null,
      selectedId: null,
      modalVisible: false,
      dialogVisible: false,
      columns: [
        {
          name: 'placeName',
          field: 'placeName',
          label: 'entities.place.fields.placeName',
          align: 'center',
        },
        {
          name: 'placeType',
          field: 'placeType',
          label: 'entities.place.fields.placeType',
          align: 'center',
        },
        {
          name: 'country',
          field: 'country',
          label: 'entities.place.fields.country',
          align: 'center',
        },
        {
          name: 'city',
          field: 'city',
          label: 'entities.place.fields.city',
          align: 'center',
        },
        { 
          name: 'action', 
          field: 'action', 
          label: 'common.action',
          align: 'center', 
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      rows: 'place/list/rows',   
      loading: 'place/list/loading',
      pagination: 'place/list/pagination',
      destroyLoading: 'place/destroy/loading',

      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
    }),
    hasPermissionToEdit() {
      return new PlacePermissions(this.currentUser).edit;
    },
    hasPermissionToDestroy() {
      return new PlacePermissions(this.currentUser).destroy;
    },
    fields() {
      return fields;
    },
    language() {
      return vueI18n.locale
    },
    tablePagination: {
      get: function() {
        return {
          page: this.pagination.page || 1,
          rowsPerPage: this.pagination.limit || 10,
          sortBy: this.pagination.orderBy || 'createdAt',
          descending: this.pagination.sortBy == 'desc',
          // rowsNumber: xx if getting data from a server
        }
      },

      set: function(value) {
        console.log(value);
      },
    },
    pagesNumber() {
      return Math.ceil(this.rows.length / this.tablePagination['rowsPerPage']);
    },
  },

  methods: {
    ...mapActions({
      doFetch: 'place/list/doFetch',
      doDestroy: 'place/destroy/doDestroy',
      doMountTable: 'place/list/doMountTable',
      doChangeSort: 'place/list/doChangeSort',
      doChangePaginationCurrentPage: 'place/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize: 'place/list/doChangePaginationPageSize',
    }),
    i18n(key, args) {
      return this.$t(key, args);
    },
    presenter(record, fieldName) {
      const val = PlaceModel.presenter(record, fieldName);
      return val ? val : 'ـــ'
    },
    presenterEnum(row, fieldName) {
      const options = this.fields[fieldName].options;
      const val = options.filter(el => el.value == row[fieldName])
      return val.length ? this.i18n(val[0].i18n) : 'ـــ';
    },
    presenterMap(row, fieldName) {
      const val = row[fieldName]
      const valueEn = val ? val['en'] : null
      const valueAr = val ? val['ar'] : null
      const value = this.currentLanguageCode == 'ar'
        ? valueAr ? valueAr : valueEn
        : valueEn ? valueEn : valueAr
      return value ? value : 'ـــ'
      // return val[this.currentLanguageCode] ? val[this.currentLanguageCode] : 'ـــ'; 
    },
    presenterDateTime(row, fieldName) {
      const val = row[fieldName]
      return val ? moment(val).locale(this.currentLanguageCode).format("DD-MM-YYYY h:mm A") : 'ـــ'; 
    },
    presenterDate(row, fieldName) {
      const val = row[fieldName]
      return val ? moment(val).locale(this.currentLanguageCode).format("D MMM, YYYY") : 'ـــ'; 
    },
    presenterDay(row, fieldName) {
      const val = row[fieldName]
      return val ? moment(val).locale(this.currentLanguageCode).format("dddd") : 'ـــ'; 
    },
    presenterTime(row, fieldName) {
      const date = row[fieldName]
      return moment(date, "YYYY-MM-DD'T'hh:mm:ss.SSS'Z'").locale(this.currentLanguageCode).format('hh:mm a')
    },

    onModalOpen(row) {
      this.selectedRow = row;
      this.selectedId = row.id;
      this.modalVisible = true
      this.dialogVisible = true
    },
    onModalClose() {
      this.selectedRow = null;
      this.selectedId = null;
      this.dialogVisible = false;
      setTimeout(() => {
        this.modalVisible = false;
      }, 200);
    },
    async doDestroyWithConfirm(id) {
      try {
        await this.doDestroy(id);
        this.onModalClose();
      } catch (error) {
        // no
      }
    },

    async doFetchFirstPage() {
      return this.doFetch({
        status: 'accepted',
        orderBy: 'createdAt',
        pagination: { sortBy: 'desc', limit: 10 }
      });
    },
    async doFetchPrevPage() {
      const firstDocument = this.rows[0]
      return this.doFetch({
        status: 'accepted',
        orderBy: 'createdAt',
        pagination: {
          sortBy: 'desc',
          limit: 10,
          doc: firstDocument,
          action: 'prev'
        }
      });
    },
    async doFetchNextPage() {
      const lastDocument = this.rows[this.rows.length - 1]
      return this.doFetch({
        status: 'accepted',
        orderBy: 'createdAt',
        pagination: {
          sortBy: 'desc',
          limit: 10,
          doc: lastDocument,
          action: 'next'
        }
      });
    },
  },
};
